import { IGenericDataFetchParams, createGenericDataFetch } from "../generic/GenericDataActions";
import { IDelivery } from "types/backend_models/deliveries/IDelivery";
import { setFetchDeliveryPending, setFetchDeliverySucces, setFetchDeliveryError } from "redux/reducers/data_action_reducers/deliveries/DeliveryDataReducer";

var fetchParams: IGenericDataFetchParams<IDelivery> = {
	apiEndPoint: '',
	pendingActionCreator: setFetchDeliveryPending,
	succesActionCreator: setFetchDeliverySucces,
	errorActionCreator: setFetchDeliveryError
}

export function fetchSingleDelivery(deliveryId: number)
{
	fetchParams.apiEndPoint = `customer/deliveries/${deliveryId}`;
	return createGenericDataFetch<IDelivery>(fetchParams); 
}